// Which takeoff rows belong on the drawing being viewed.
//
// A placed room or a drawn / placed condition instance belongs to exactly ONE
// drawing sheet (TakeoffRooms.SheetID, TakeoffConditionsDrawn.SheetID); the
// condition TYPE (an Item / Assembly) is revision-wide, so the same HEPA, door
// or light is taken off across many drawings. The canvas shows only the active
// sheet's instances; schedules, engines and the estimate keep the full lists
// and sum across every sheet.
//
// A row with NO sheet shows on every drawing: an unplaced room waiting in the
// tray, a manual (geometry-less) condition, or a legacy row in a revision that
// had no drawing when ownership was introduced. With no active drawing at all
// (a revision that has none) everything shows, as before.

export function isOnSheet(activeSheetId, rowSheetId) {
  return activeSheetId == null || rowSheetId == null || rowSheetId === activeSheetId;
}

export function filterToSheet(rows, activeSheetId) {
  return rows.filter(r => isOnSheet(activeSheetId, r.SheetID));
}

// Rows grouped by sheet (rows with no sheet share the "none" group) — used to
// detect wall adjacency within a drawing only: rooms on different sheets share
// one coordinate space but not a physical location.
export function groupBySheet(rows) {
  const groups = new Map();
  for (const r of rows) {
    const k = r.SheetID ?? "none";
    (groups.get(k) || groups.set(k, []).get(k)).push(r);
  }
  return groups;
}
